import React from 'react';
export function Footer() {
  return <footer className="bg-gray-900 text-white py-8 px-4" data-id="element-123">
      <div className="max-w-6xl mx-auto" data-id="element-124">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-125">
          <div data-id="element-126">
            <h3 className="text-lg font-bold mb-4" data-id="element-127">Hair Growth Oil 3.0</h3>
            <p className="text-sm text-gray-400" data-id="element-128">
              The revolutionary hair growth formula that targets environmental
              causes of hair loss at the cellular level.
            </p>
          </div>
          <div data-id="element-129">
            <h3 className="text-lg font-bold mb-4" data-id="element-130">Quick Links</h3>
            <ul className="text-sm text-gray-400 space-y-2" data-id="element-131">
              <li data-id="element-132">
                <a href="https://hair-haven.com/pages/shipping-policy" className="hover:text-white transition-colors" data-id="element-133">
                  Shipping Policy
                </a>
              </li>
              <li data-id="element-134">
                <a href="https://hair-haven.com/pages/refund-policy" className="hover:text-white transition-colors" data-id="element-135">
                  Refund Policy
                </a>
              </li>
              <li data-id="element-136">
                <a href="https://hair-haven.com/pages/terms-of-service" className="hover:text-white transition-colors" data-id="element-137">
                  Terms of Service
                </a>
              </li>
              <li data-id="element-138">
                <a href="https://hair-haven.com/pages/privacy-policy" className="hover:text-white transition-colors" data-id="element-139">
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-140">
            <h3 className="text-lg font-bold mb-4" data-id="element-141">Contact Us</h3>
            <p className="text-sm text-gray-400 mb-2" data-id="element-142">
              Email: contact@hair-haven.com
            </p>
            <p className="text-sm text-gray-400" data-id="element-143">Phone: 212-444-3144</p>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-8 pt-6 text-center text-sm text-gray-500" data-id="element-144">
          <p data-id="element-145">
            &copy; {new Date().getFullYear()} Hair Growth Oil 3.0. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
}
export default {
  Footer
};